import React from 'react';
import { isActiveUser } from '../../utils/activeUsers';

// The Status column in people tables: Active, or Inactive once the account
// is deactivated (/users/deactivate). Same pill as the Users table's Verified.
const ActiveStatusBadge: React.FC<{ user?: object | null }> = ({ user }) => {
    const active = isActiveUser(user);
    return (
        <span className={`inline-flex items-center px-3 py-1 rounded-full text-[11px] font-semibold border whitespace-nowrap ${active
            ? 'bg-emerald-50 text-emerald-600 border-emerald-200/50'
            : 'bg-red-50 text-red-600 border-red-200/50'
            }`}>
            {active ? 'Active' : 'Inactive'}
        </span>
    );
};

export default ActiveStatusBadge;
